// extracted by mini-css-extract-plugin
module.exports =  {"borderHighlight":"Y7Ld94utJy0yHyyLpNGO","borderHighlightLoop":"XwSh1rUjYYvOvFk7ryJA"};